import { useEffect } from 'react';
import { useKart } from '../skall/kart.tsx';
import { useSmal } from '../skall/useSmalSkjerm.ts';
import { Ikon } from '../status/Ikon.tsx';
import type { Tast } from './Tastaturkart.tsx';

/**
 * Tastaturkart-knappen i sidens topp.
 *
 * Sto tidligere kun i SakerSide, altså på to av fem sider — mens kartets siste rad
 * dokumenterte snarveiene som er bundet globalt i Skall.tsx.
 *
 * R4.3 flyttet tilstanden, `?`-bindingen og dialogen til skallet (DD-11 presisert, P4):
 * kartet har to innganger — dette ikonet over 900 px og raden i «⋯» under — og to
 * innganger til samme dialog kan ikke eie hver sin tilstand. Igjen her står HVA kartet
 * skal vise, fordi tastene er sidens egne (innboksens `j`/`k` virker ikke på
 * Innstillinger), og selve ikonet, som bare finnes over grensen (avvik 15).
 */
export function Kartknapp({ tittel, taster }: { tittel: string; taster: Tast[] }) {
  const kart = useKart();
  const smal = useSmal();

  useEffect(() => {
    kart.meldInn(tittel, taster);
    return () => kart.rydd();
  }, [kart, tittel, taster]);

  if (smal) return null;

  // F7: en rund ikonknapp, ikke sidens mest synlige knapp. Navnet står i aria-label og title.
  return (
    <button type="button" className="panel-kart-knapp" onClick={kart.aapne} title="Tastaturkart (?)" aria-label="Tastaturkart (?)" aria-keyshortcuts="?" data-testid="kart-knapp">
      <Ikon navn="help-circle-outline" />
    </button>
  );
}
